import './CompetitionTranslationsWidget.less';
import { RouterLink } from '@/router';
import Vue from 'vue';
import { gql } from 'apollo-boost';
import { VDataTable, VTextField, VIcon } from 'vuetify/lib';

export default Vue.extend({
  name: 'competitorTranslationsWidget',
  props: {
    name: String,
    sportId: Number,
    locale: String,
    competitionId: Number,
    disableNameLimitSearch: Boolean,
  },
  data() {
    return {
      competitors: [],
      headers: [
        { text: 'Id', value: 'id', width: 100 },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Translation', value: 'translation', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    entityLink(props: any): JSX.Element {
      return (
        <RouterLink
          class='text-decoration-none'
          to={{ name: 'competitor', params: { competitorId: props.item.id } }}
        >
          {props.item.id}
        </RouterLink>
      );
    },
    editTranslation(props: any): JSX.Element {
      return <VTextField vModel={props.item.translation} />;
    },
    actions(props: any): JSX.Element {
      return (
        <VIcon
          disabled={
            props.item.translation.length === 0 ||
            props.item.currentTranslation === props.item.translation
          }
          onClick={async () => {
            const res = await this.$apollo.mutate({
              mutation: gql`
                mutation($input: TranslationInput!) {
                  updateTranslation(input: $input) {
                    success
                  }
                }
              `,
              variables: {
                input: {
                  entityType: 'competitor',
                  id: props.item.id,
                  locale: this.locale,
                  value: props.item.translation,
                },
              },
              context: {
                hasUpload: true,
              },
            });
            if (res.data.updateTranslation.success) {
              props.item.currentTranslation = props.item.translation;
            }
          }}
        >
          save
        </VIcon>
      );
    },
    itemRowBackground(item: any): string {
      return item.currentTranslation !== item.translation ? 'bg-yellow' : '';
    },
  },
  computed: {
    sportsKeysMap(): any {
      return this.$store.state.sportsConsts.sportsKeysMap;
    },
  },
  apollo: {
    competitors: {
      skip(): boolean {
        return this.disableNameLimitSearch ? false : this.name.length < 3;
      },
      query: gql`
        query(
          $name: String
          $sportId: Int
          $locale: String!
          $competitionId: Int
        ) {
          searchCompetitors(
            name: $name
            sportId: $sportId
            locale: $locale
            competitionId: $competitionId
          ) {
            competitors {
              id
              name
              key
              translation
            }
          }
        }
      `,
      variables(): {
        name: string;
        sportId: number;
        locale: string;
        competitionId: number;
      } {
        return {
          name: this.name,
          sportId: this.sportId,
          locale: this.locale,
          competitionId: this.competitionId,
        };
      },
      update(data) {
        return data.searchCompetitors.competitors.map((c: any) => {
          c.currentTranslation = c.translation;
          return c;
        });
      },
      fetchPolicy: 'network-only',
    },
  },
  render() {
    const dataTable = (
      <VDataTable
        headers={this.headers}
        items={this.competitors || []}
        itemClass={this.itemRowBackground}
        sortBy={'id'}
        scopedSlots={{
          'item.id': this.entityLink,
          'item.translation': this.editTranslation,
          'item.actions': this.actions,
        }}
        loading-text='Loading... Please wait'
        loading={this.$apollo.queries.competitors.loading}
      />
    );
    if (this.disableNameLimitSearch) {
      return <div>{dataTable}</div>;
    }
    return (
      <div>
        {this.name.length < 3 ? (
          <div class='px-4'>Please enter name with at least 3 characters</div>
        ) : (
          dataTable
        )}
      </div>
    );
  },
});
